import { DataSource } from '@angular/cdk/table';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { CategoryDto } from '@careapp-group/ng-sdk-v2-new';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'memo-categories-table',
  styleUrls: ['./memo-categories-table.component.scss'],
  templateUrl: './memo-categories-table.component.html',
})
export class MemoCategoriesTableComponent implements OnInit {
  _readOnly = false;
  ordinals = new Map();
  @Output() remove = new EventEmitter();
  @Output() save = new EventEmitter();
  @Input()
  set categories(data: CategoryDto[]) {
    if (data && data.length) {
      this.ordinals.clear();
      data.forEach((row) =>
        this.ordinals.set(
          row.id,
          new UntypedFormControl({
            value: row.ordinal ?? '',
            disabled: this._readOnly,
          })
        )
      );
    }
    this.dataChange.next(data);
  }

  @Input() set readOnly(value: boolean) {
    if (value === true) {
      this._readOnly = true;
      this.ordinals.forEach((o: UntypedFormControl) => o.disable());
    }
  }

  @Input() dataChange: BehaviorSubject<CategoryDto[]> = new BehaviorSubject([]);
  dataSource: MemoCategoryDataSource;
  displayedColumns: string[];

  ngOnInit() {
    this.displayedColumns = ['icon', 'name', 'order', 'action'];
    this.dataSource = new MemoCategoryDataSource(this.dataChange.asObservable());
  }
}

export class MemoCategoryDataSource extends DataSource<any> {
  constructor(public data: Observable<CategoryDto[]>) {
    super();
  }

  connect(): Observable<CategoryDto[]> {
    return this.data;
  }

  disconnect() {
    // lint
  }
}
